import _ from "lodash";

import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import {
  Button,
  ButtonToolbar,
  Col,
  Container,
  Row,
} from "react-bootstrap";
import WaypointReplacement from "App/legacy/react-waypoint";
import cls from "classnames";
import $ from "jquery";

import uiconfig from "CommonState/uiconfig";
import store from "CommonState/store";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  Awesome,
  Panel,
  Pill,
} from "CommonComponents/bricks";
import helpApi, {
  articleToAnchor,
  createMockHelp,
  hilfeTree,
} from "Apis/help-api";
import {
  routes as mainRoutes,
} from "App/routes";
import {
  MarkdownPreview,
} from "CommonComponents/markdown-editor";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";

import {
  setupLookups,
} from "App/shk-form-tab";


const schemaHidectrl = { table: [{ field: "showOnlyHidden", type: "checkbox", display: "Nur versteckte" }] };
setupLookups(schemaHidectrl);

@uiconfig
@withLocation
@helpApi.list
@store(hilfeTree)
export default class HelpPage extends Component {
  constructor() {
    super();
    this.state = {
      edited: {},
      showOnlyHidden: false,
    };
    this.sectionRefs = {};
    this.visibleSections = {};
  }

  componentDidMount() {
    $(window).on("scroll", this.updateToc);
  }

  componentWillUnmount() {
    $(window).off("scroll", this.updateToc);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.lastAnchor = void 0;
    }
  }

  renderNode = (node, renderer) => {
    const id = articleToAnchor(node.data);
    return renderer(node, id, _.map(node.children, child => this.renderNode(child, renderer)));
  };

  renderHelpNode = (node, id, children) => {
    const { ifAllowed } = this.props;
    const { data: hi } = node;
    const { showOnlyHidden } = this.state; // Zugriff auf showOnlyHidden

    // NEUE LOGIK: Filtere basierend auf showOnlyHidden
    if (showOnlyHidden && !hi.hi_hidden) {
      /*
       * Wenn nur versteckte angezeigt werden sollen und dieser Eintrag nicht versteckt ist
       * Gib nur die Kinder zurück (falls vorhanden und gefiltert)
       */
      const filteredChildren = children.filter(child => child != null);
      return filteredChildren.length > 0 ? <div key={hi.hi_id}>{filteredChildren}</div> : null;
    }

    const { location } = this.props;
    if (location.hash !== this.lastAnchor && location.hash === "#" + id) {
      this.lastAnchor = location.hash;
      setTimeout(() => {
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView();
        }
      }, 50);
    }

    const preview = <MarkdownPreview value={hi.hi_text} />;
    const newButton = ifAllowed(
      "new.hilfe",
      <Button variant='link' data-id={hi.hi_id} onClick={this.newHelp}><Awesome name='plus' /></Button>,
    );
    const editButton = ifAllowed(
      "edit.hilfe",
      <Button variant='link' data-id={hi.hi_id} onClick={this.editHelp}><Awesome name='pencil-alt' /></Button>,
    );
    const hasChildren = !_.isEmpty(node.children);
    const deleteButton = !hi.hi_pfad && hi.hi_master_hiid && ifAllowed(
      "delete.hilfe",
      <Button
        variant='link' data-id={hi.hi_id} onClick={this.deleteHelp}
        disabled={hasChildren} title={hasChildren && "Hilfebeiträge mit untergeordneten Beiträge dürfen nicht gelöscht werden."}>
        <Awesome name='trash' />
      </Button>,
    );

    return node.depth === 0
      ? <div key={hi.hi_id}>
        {preview}
        {children}
        <ButtonToolbar className='card-header-toolbar card-header-toolbar-top'>
          {newButton}
          {editButton}
        </ButtonToolbar>
      </div>
      : <WaypointReplacement
        key={hi.hi_id}
        scrollableAncestor={window}
        onEnter={() => this.onSectionEnterLeave(node, true)}
        onLeave={() => this.onSectionEnterLeave(node, false)}>
        <div style={{ position: "relative" }} ref={r => this.sectionRefs[hi.hi_id] = r}>
          <Panel id={id} header={
            <span className='header-with-badge'>
              <h3>{hi.hi_titel}</h3>
              {hi.hi_hidden && ifAllowed(
                "edit.hilfe",
                <Pill variant='warning'>Versteckt</Pill>,
              )}
            </span>
          }>

            {preview}
            <p><em>{hi.hi_schlagwoerter}</em></p>
            {children}
          </Panel>
          <ButtonToolbar className='card-header-toolbar'>
            {newButton}
            {editButton}
            {deleteButton}
          </ButtonToolbar>
        </div>
      </WaypointReplacement>;
  };

  renderTocNode = ({ data: hi, depth }, id, children) => {
    const isGroup = depth === 1;
    const { topNode, showOnlyHidden } = this.state;
    const isHighlighted = topNode && topNode.data.hi_id === hi.hi_id;
    return (
       !showOnlyHidden || (hi.hi_hidden && showOnlyHidden)
? <li
  key={hi.hi_id}
  className={cls({
    "section-group": isGroup,
    "section-group-open": isHighlighted || (topNode && topNode.sectionNode && topNode.sectionNode.data.hi_id === hi.hi_id) || (hi.hi_hidden && showOnlyHidden),
    "section-highlighted": isHighlighted,
  })}
>
  <a href={"#" + id}>{hi.hi_titel}</a>
  {!_.isEmpty(children) && <ul>{children}</ul>}
</li>
: !_.isEmpty(children) && <ul key={hi.hi_id} style={{ paddingLeft: "20px" }}>{children}</ul>
    );
  };

  updateTocImpl = () => {
    const { visibleSections, sectionRefs } = this;
    const contenders = _.values(visibleSections)
      .map(visNode => {
        const $element = $(sectionRefs[visNode.data.hi_id]);
        const offset = $element.offset();
        return offset && {
          node: visNode,
          top: offset.top - $(document).scrollTop(),
        };
      })
      .filter(data => data && data.top < 100);
    const top = _.maxBy(contenders, ({ top }) => top);
    if (top && top.node.parent) {
      this.setState({ topNode: top.node });
    }
  };
  updateToc = _.debounce(this.updateTocImpl, 50, { maxWait: 50 });

  onSectionEnterLeave = (node, visible) => {
    const { visibleSections } = this;
    const id = node.data.hi_id;
    if (visible) {
      visibleSections[id] = node;
    } else {
      delete visibleSections[id];
    }
  };

  newHelp = ({ currentTarget }) => {
    this.props.history.push(`/hilfe/new?master=${ currentTarget.getAttribute("data-id") }`);
  };

  editHelp = ({ currentTarget }) => {
    this.props.history.push(`/hilfe/${ currentTarget.getAttribute("data-id") }`);
  };

  deleteHelp = ({ currentTarget }) => {
    this.props.deleteHilfe(currentTarget.getAttribute("data-id"));
  };

  setOnlyHidden = (schema, value) => {
    this.setState({ showOnlyHidden: value });
  };

  render() {
    const { hilfeTree, ifAllowed } = this.props;
    const { showOnlyHidden } = this.state; // Explizit für Re-Rendering

    return <Container fluid>
      <Breadcrumb name='Hilfe' path='/hilfe' />
      <Row>
        <Col lg={10} xs={8}>
          <div key={`help-content-${ showOnlyHidden }`}>
            {_.map(hilfeTree, node => this.renderNode(node, this.renderHelpNode))}
          </div>
        </Col>
        <Col lg={2} xs={4}>
          <div className='help-toc'>
            {ifAllowed("edit.hilfe", ControlGenerators.checkbox({
              entity: this.state,
              schema: schemaHidectrl.table[0],
              leftCol: 0,
              rightCol: 12,
              onChange: this.setOnlyHidden,
            }))}
            <ul>{
              _.map(
                hilfeTree && hilfeTree[0] && hilfeTree[0].children,
                node => this.renderNode(node, this.renderTocNode),
              )
            }</ul>
          </div>
        </Col>
      </Row>
    </Container>;
  }

  genHelp() {
    const result = [];
    console.log(JSON.stringify(createMockHelp(mainRoutes, result)));
  }
}
